<template>

        <el-container style="height: 100%;">
          <el-aside style="width: auto;z-index: 9999 ; overflow: hidden;overflow-y: hidden" >
                      <div class="sidebar-container has-logo">
                          <div class="block">
                              <el-avatar :size="45" :src="circleUrls">
                              </el-avatar>
                              <div class="text"> <h3>{{ operatorName }}单车</h3><p>Enterprise client</p></div>
                          </div>
                      </div>
          <el-menu  class="el-menu-vertical" :collapse="isCollapse" :default-active="isSelect.toString()"   :unique-opened = "true" :router="true">
            <el-menu-item  v-for="(item,index) in menus"  :key="index" :index="item.id" :route="item.url">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
            <el-menu-item @click="setlogout()" key="5"  index="5">
              <i class="el-icon-switch-button"></i> 退出
            </el-menu-item>
            <div class="bottom" ><img src="../assets/images/p.png" /></div>


          </el-menu>


        </el-aside>

        <el-container>
			

            <el-main>
                   <router-view :curId = "curIds" :circleUrl="circleUrls"></router-view>
            </el-main>

        </el-container>
    </el-container>


</template>
<script>

export default ({
    name:"Main",
    data(){
      return {
        isCollapse:false,
               newdata:'',
               circleUrls:'',
               isSelect:'',
               curIds:'',
        operatorName:'',
                menus:[
                {
                    name:'总览',
                    icon:'el-icon-s-marketing',
                    id: '1',
                    url:'/index'

                },
                  {
                    name:'评分详情',
                    icon:'el-icon-upload',
                    id: '2',
                    url:'/Operaview'

                  },

                {
                    name:'资料上传',
                    icon:'el-icon-upload',
                    id: '3',
                     url:'/upload'

                },
                {
                    name:'修改密码',
                    icon:'el-icon-s-custom',
                    id: '4',
                      url:'/install'

                },
            ],
            }
    },
         beforeRouteEnter(to,from,next){
            // console.log(123);
             next((vm)=>{
                 vm.isLogin();

                 vm.Setis();
                 //vm.getUserMenus();
             });
         },
        created(){
          this.getUserInfo();
        },
          watch: {

          },
        mounted () {
                window.setInterval(() => {
                    this.getdata()
                }, 1000);
          this.getUserInfo();
        },
        methods: {
            Setis(){

                  this.isSelect =  this.$route.meta.id;
                 // console.log(this.isSelect);

            },
            getdata(){
                let myDate = new Date();
                let year = myDate.getFullYear(); //获取当前年
                let mon = myDate.getMonth() + 1; //获取当前月
                let date = myDate.getDate(); //获取当前日
                let h = myDate.toLocaleTimeString();//获取当前小时数(0-23)前秒
                let week = myDate.getDay();
                let weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
                this.newdata = year + "年" + mon + "月" + date + "日      " + weeks[week] +"      "+ h
            },

              isLogin(){
                  let that = this;
               this.$axios.defaults.withCredentials = true;
                this.$axios
                    .get('/webapi/isLogin')
                    .then(function (res) {

                        if(res.data.data==false){
                            that.$message.error("登录超时");
                          window.setTimeout(() => {
                            that.$router.push({name:'Login'})
                          }, 1000);
                        }
                    }).catch(function (error) { // 请求失败处理
                    console.log("服务器错误"+error);
            });
        },

        getUrlKey (name) {
            return decodeURIComponent(
                (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
        },
        getUserInfo(){
            var that = this;
            if(this.getUrlKey('id')!=null){
                this.cid = this.getUrlKey('id');
            }else{
                this.cid =1;
            }

            this.$axios.defaults.withCredentials=true;
            this.$axios
                .get('/webapi/user/getUserInfo')
                .then(function (res) {
                  console.log(res)
                    if(res.data.code==200){
                        that.circleUrls=res.data.data.avatar;
                        that.curIds = res.data.data.operatorNum;
                        that.userid = res.data.data.userId;
                        that.operatorName = res.data.data.operatorName;
                    }
                }).catch(function (error) { // 请求失败处理
                console.log("服务器错误"+error);
            });
        },

          setlogout(){
            var that = this;
            this.$axios.defaults.withCredentials=true;
            this.$axios
              .get('/webapi/logout')
              .then(function (res) {
                if(res.data.code==200){
                  that.$message({
                    message: '退出成功',
                    type: 'success'
                  });
                  window.setTimeout(() => {
                      that.$router.push({name:'Login'});
                  }, 1000);

                }else {
                  that.$message.error('退出失败');
                }

              }).catch(function (error) { // 请求失败处理
              console.log("服务器错误"+error);
            });
          },



        },



})
</script>
<style>
@import '../assets/css/comm.css';
</style>
<style scoped>
@import '../assets/css/style.css';
.uploadIcon {
    display: none !important; /* 上传按钮隐藏 */
}
    html,body,#app {
        height: 100%;
        margin: 0;
        padding: 0;
    }
    .el-message-box{
       width: 800px;
    }
    .el-table__header{
        width: 100%!important;
    }
    #app {

        background: rgba(0,0, 0, 0.05);
    }
    .el-container{
        height: 100%;
    }

    .el-header, .el-footer {
        width: 100%;
        height: 88px;
        background: #FFFFFF;
        box-shadow: -10px 10px 20px 0px rgba(30, 30, 30, 0.05);
        margin: 30px auto;
        padding: 0 60px;
    }
    .el-header h1{
        line-height:60px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #222222;
        float: left;
        margin: 0;
    }
    .el-header span{
        float: right;
        line-height: 60px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #444444;
    }
    .el-main {
        width: 100%;
        color: #333;
        text-align: center;
		background-color: #cca8a8;
    }
    .el-table td, .el-table th.is-leaf,.el-table--border, .el-table--group{
        border-color: #EDEFF5;
    }
    .el-table--border::after, .el-table--group::after, .el-table::before{
        background-color: #EDEFF5;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #109585;
        color: #fff;
    }
    .el-pagination.is-background .el-pager li:hover{
        color: #fff!important;
        background-color: #109585 !important;
    }
    .table-box {
         width:95%;
        padding: 30px;
        background: #FFFFFF;
    }
    .el-table th > .cell {
        text-align: center;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #000000;
    }

   .el-table .cell {
        text-align: center;
    }
    .el-table thead tr{
        background: none;
        box-shadow: 0px 5px 10px 0px rgba(0,0,0 ,0.1);
    }


    .el-table .el-button--success{

        background: #109585;
        border-radius: 4px;
        border-color: #109585;
    }

    body > .el-container {
        margin-bottom: 40px;
    }

    .el-container:nth-child(5) .el-aside,
    .el-container:nth-child(6) .el-aside {
        line-height: 260px;
    }

    .el-container:nth-child(7) .el-aside {
        line-height: 100%;
    }
    .el-pagination{
            padding: 16px 5px;
    }

.el-menu{background: #cca8a8}
.el-menu-item.is-active{
  background-color: #cca8a8;
  color: #409EFF;
}
.el-menu-item:hover{outline:0;background-color:#cca8a8!important; }
.el-menu-item{
  color:#303133;
  font-size: 14px;
}


</style>



// WEBPACK FOOTER //
// src/view/Main.vue